import axios from "axios";
import UserService from "../services/UserService.js";

const serverConfig = require("../config/server.js");

/**
 * Log a workflow action to the backend
 * @param {string} applicationNumber - The application number
 * @param {string} action - The action being performed (e.g., 'process', 'score', 'review', 'underwrite', 'decision')
 * @param {object} data - Additional data to log with the action
 * @returns {Promise} - The axios promise
 */
export const logWorkflowAction = async (
  applicationNumber,
  action,
  data = {}
) => {
  try {
    const user = UserService.getUsername();

    const payload = {
      applicationNumber: String(applicationNumber),
      user: user || "anonymous",
      action,
      data: data,
    };

    return await axios.post(
      `${serverConfig.api_base_url}underwriting-engine/workflow-logs`,
      payload
    );
  } catch (error) {
    console.error("Error logging workflow action:", error);
    // Don't throw the error to avoid breaking the main flow
    return Promise.resolve();
  }
};

/**
 * Get workflow logs for a specific application
 * @param {string} applicationNumber - The application number
 * @returns {Promise<Array>} - The workflow logs
 */
export const getWorkflowLogs = async (applicationNumber) => {
  try {
    const response = await axios.get(
      `${serverConfig.api_base_url}underwriting-engine/workflow-logs/${applicationNumber}`
    );
    return response.data.logs || [];
  } catch (error) {
    console.error("Error fetching workflow logs:", error);
    return [];
  }
};
